



  $(document).ready(function(){
    
    //////
      //Initialisation du bouton add to cart au chargement de la page
    //////
		
    var $product_price = $('.product-form__info-list');
    var $btn_add_to_cart = $('.product-form__payment-container button[type="submit"]');
    
      //Si le champs input existe on rend le bouton "Add to cart" disable (addClass disable + stop click avec js)
      //On met à jour si le champs cp est renseigné
      $btn_add_to_cart.on('click', function(e){
          if ( $('#postal-code').length != 0 && $('#postal-code').attr('data-cp-finded') == 'false' ) {
              e.stopImmediatePropagation();
              e.preventDefault();	
          }
        });
    
    //On ajoute la class disable au chargement
      if ( $('#postal-code').length != 0 && $('#postal-code').attr('data-cp-finded') == 'false') {
        
		//On rend l'ajout au panier possible
        $btn_add_to_cart.addClass('disabled');
        $btn_add_to_cart.attr('data-disabled','true');
        
        //On cache le prix
		$product_price.slideUp(200);
      }


    //////
      //Création des fonctions de crawl et d'update du select
    //////

      //Fonction qui rend l'ajout au panier impossible 
      function disable_add_to_cart() {
        //On update l'attribut pour signifier que le code postal n'a pas été trouvé
        $('#postal-code').attr('data-cp-finded','false');

        //On rend l'ajout au panier possible
        $btn_add_to_cart.addClass('disabled');
		$btn_add_to_cart.attr('data-disabled','true');
        
        //On cache le prix
		$product_price.slideUp(200);
      }
    
      function able_add_to_cart() {
		//On rend l'ajout au panier possible
        $btn_add_to_cart.removeClass('disabled');
        $btn_add_to_cart.removeAttr('data-disabled');
        
        //On cache le prix
		$product_price.slideDown(400);
      }

      //Fonction qui crawle à travers un fichier .csv pour trouver un code postal et renvoyer le typede Livraison associée  
      function crawl_csv(value_cp,book_type,count_caracter) {

      //Récupère la variable liquid de l'URL du fichier en fonction du booktype
        if ( book_type == 'JDM' ) {
          	var url = "//www.jemagazine.ca/cdn/shop/files/JDM_CODES_POSTAUX.csv?v=9294697314326147159";
        } else if ( book_type == 'JDQ' ) {
         	var url = "//www.jemagazine.ca/cdn/shop/files/JDQ_CODES_POSTAUX.csv?v=484502522702014645"; 
        }

        //On récupère le fichier en AJAX
        $.ajax({
          type: "GET",
          url: url,
          dataType: "text",
          success: function(data) {processData(data);}
        });

        function update_shipping_select(shipping_type) {

          //On récupère la value du select qui est sélectionnée
          var $shipping_selected = $('.product-form__option.type-livraison');
          var $all_option_shipping = $shipping_selected.find('.block-swatch-list > .block-swatch input');
          var value_shipping_selected = $shipping_selected.find('input[type="radio"]:checked').attr('data-value');
	
          
          //Si la valeur du select est différente du type de livraison associé au Code postal renseigné
          if (value_shipping_selected != shipping_type) {

            //On crawl à travers les options du select
            $all_option_shipping.each(function(){
              var value_type = $(this).attr('data-value');
			
              //Si la valeur de l'option est égale à celle de celle récupéré du .csv
              if (value_type == shipping_type) {
                  $all_option_shipping.not($(this)).removeAttr('checked');
                                           
                  //On update l'option selected
                  $(this).attr('checked');
                  $(this).click();
              } else {
				$(this).removeAttr('checked');
              }	
            });
          }
        }

        function processData(allText) {
            var cp_found = false;
            var allTextLines = allText.split(/\r\n|\n/);
            var headers = allTextLines[0].split(',');
            var lines = [];

            for (var i=1; i<allTextLines.length; i++) {
                var data = allTextLines[i].split(',');

                if (data.length == headers.length) {
                    var tarr = [];
                  	var data_cp_uppercase = data[0].toUpperCase();
                  	var data_shipping = data[1];
                  	if (value_cp == data_cp_uppercase) {
                      
                      //On ajoute la valeur au tableau
                      tarr.push(data_cp_uppercase);
                      tarr.push(data_shipping);
                      
                      //On passe la variable à true
                      cp_found = true;
                    }
                }

              //Si le code postal a été trouvé dans le csv
              if ( cp_found == true ) {
                
                //On ajoute le tableau à la variable 
                lines.push(tarr);

				//On sort de la boucle
                break;
              }
            }


          //Si on trouve un code postal correspondant
          if ( cp_found == true ) {
            var row_cp_found = lines[0];
            var shipping_type = row_cp_found[1].toLowerCase().replace("ô", "o").replace("ï", "i").replace("î", "i").replace("â", "a").replace("è", "e").replace("é", "e").replace(/[\u0300-\u036f]/g, "").replace(/-$/, '').replace(/^-/, '');

            //On update l'attribut pour signifier que le code postal a été trouvé
            $('#postal-code').attr('data-cp-finded','true');

            //On joue la fonction d'update du select
            update_shipping_select(shipping_type);
			
			//On rend l'ajout au panier possible
            able_add_to_cart();
            
          } else if ( cp_found == false && count_caracter == 6 ){
              var $input_urbain = $('.product-form__option.type-livraison').find('input[data-value="urbain"]');
              var $all_input = $('.product-form__option.type-livraison').find('input');	
              $('#postal-code').attr('data-cp-finded','true');
              $all_input.not($input_urbain).removeAttr('checked');
              $input_urbain.attr('checked');
              $input_urbain.click();
			  able_add_to_cart();
            
          } else {
              disable_add_to_cart();
          }
        }
      } //END crawl_csv()

    //On joue la fonction à chaque fois que l'utilisateur modifie le champs
    var $input = $('#postal-code');

    $input.on("input", function(){
      var value_cp = $(this).val().toUpperCase();
      var count_caracter = value_cp.length;
      var book_type = $(this).attr('data-book-type');
      
      if (count_caracter == 6) {
          crawl_csv(value_cp,book_type,count_caracter);
      } else {
          disable_add_to_cart();
      }
    });

  });